import React from "react";
import { ReactNode } from "react";
import Input from "shared/Input/Input";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
  filter?: boolean;
  onFilterChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "",
  heading = "Stays in Tokyo",
  subHeading,
  filter = false,
  onFilterChange = () => {},
}) => {
  return (
    <div className={`mb-12 lg:mb-16 ${className}`}>
      <h2 className="text-4xl font-semibold">{heading}</h2>
      {subHeading ? (
        subHeading
      ) : (
        <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
          233 stays
          <span className="mx-2">·</span>
          Aug 12 - 18
          <span className="mx-2">·</span>2 Guests
        </span>
      )}
      {filter && (
        <Input
          placeholder="Cari Barang Spesifik"
          className="mt-4"
          onChange={onFilterChange}
        ></Input>
      )}
    </div>
  );
};

export default Heading2;
